module.exports = __webpack_public_path__ + "static/media/ic_cancel_k.626e2e49.svg";